import { Outlet, useParams } from 'react-router-dom'

import { ItManagementApplicationDetailsPageQueryDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ApplicationDetailsRouterOutletContextParams } from 'modules/it_management/hooks/useApplicationDetailsRouterParams'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { getSoftware } from '../lib/software'
import { useApplicationsContext } from './ApplicationsPage'

const ApplicationDetailsPage = () => {
  const { currency, loading: loadingContext, error: errorContext } = useApplicationsContext()
  const { application_id } = useParams()
  const softwareSetupId = Number(application_id)
  const companyId = useCurrentSession().company.id

  const { data, error, loading } = useQuery(ItManagementApplicationDetailsPageQueryDocument, {
    variables: {
      companyId: companyId,
      softwareSetupId: softwareSetupId,
      currency: currency,
    },
  })
  const canManagePurchaseFinancialDocuments =
    !!data?.finance._policies.financialDocumentsManagePurchase.can

  const { softwareSetup } = data?.itManagement || {}
  const software = softwareSetup ? getSoftware(softwareSetup) : undefined
  const currencies = data?.finance.exchangeCurrenciesConnection.nodes || []
  const card = softwareSetup?.card

  useEffect(() => {
    if (software) {
      track(trackingEvents.itManagement.goToSoftwareSetupDetail, {
        software_id: software.id,
        software_name: software.name,
        software_setup_id: softwareSetupId,
        with_custom_software: !!softwareSetup?.customSoftware,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ResponsivePage.Body
      authorized={!!software && !!softwareSetup}
      error={error || errorContext}
      loading={loadingContext || loading}
      showHeader={false}
    >
      {softwareSetup && (
        <Outlet
          context={
            {
              softwareSetup,
              card,
              canManagePurchaseFinancialDocuments,
              currency,
              softwareCosts: softwareSetup.monthlySoftwareCosts,
              currencies,
            } satisfies ApplicationDetailsRouterOutletContextParams
          }
        />
      )}
    </ResponsivePage.Body>
  )
}

export default ApplicationDetailsPage
